/* global moment: false */
import * as aTypes from '../action-types'
import * as mTypes from '../mutation-types'
import api from '../../api'
import { getLocalStorageItem, setLocalStorageItem } from '../../utils'

const state = {
  stats: [{
    value: 0,
    title: '联系人',
    to: {
      path: '/main/contact'
    }
  }, {
    value: 0,
    title: '表单反馈',
    to: {
      path: '/main/form'
    }
  }, {
    value: 0,
    title: '收款',
    to: {
      path: '/main/cf'
    }
  }, {
    value: 0,
    title: '活动报名',
    to: {
      path: '/main/activity'
    }
  }],
  news: [],
  currentPage: 1,
  hasMore: true,
  isGifted: true
}

/*
const sampleStat = [123, 456, 789, 8.8]
*/
/*
const sampleNews = [{
  title: '羊宝宝和小兔兔的展览筹款',
  dateTime: '2010-10-18 23:00',
  data: {
    id: '123456',
    type: 'cf',
    num: 3,
    money: 123.45
  }
}, {
  title: '羊宝宝和小兔兔的展览筹款',
  dateTime: '2010-10-18 23:00',
  data: {
    id: '234567',
    type: 'form',
    num: 4
  }
}, {
  title: '羊宝宝和小兔兔的展览筹款',
  dateTime: '2010-10-18 23:00',
  data: {
    id: '345678',
    type: 'cf',
    num: 3,
    money: 123.45
  }
}]
*/

const actions = {
  [aTypes.DASHBOARD_GET_STAT] ({ commit }) {
    commit(mTypes.SET_LOADING, { key: aTypes.DASHBOARD_GET_STAT, loading: true })
    api.dashboard.getStat({
      success (res) {
        commit(mTypes.DASHBOARD_SET_STAT, [
          res.body.contact_count,
          res.body.formfill_count,
          res.body.sum_donate_amount,
          res.body.activity_signup_user_count
        ])
        commit(mTypes.SET_LOADING, { key: aTypes.DASHBOARD_GET_STAT, loading: false })
      },
      commit
    })
  },
  [aTypes.DASHBOARD_GET_NEWS] ({ commit }, { page, append }) {
    commit(mTypes.SET_LOADING, { key: aTypes.DASHBOARD_GET_NEWS, loading: true })
    api.dashboard.getNews({
      success (res) {
        const news = res.body.map(n => {
          if (n.news_type === 'form') {
            return {
              title: n.title,
              dateTime: moment.unix(n.last_fill_time).format('YYYY-MM-DD HH:mm'),
              data: {
                id: n.id,
                type: 'form',
                num: n.formfill_count,
                enablePrivateForm: n.enable_private_form
              }
            }
          } else if (n.news_type === 'activity_signup') {
            return {
              title: n.title,
              dateTime: moment.unix(n.last_sign_time).format('YYYY-MM-DD HH:mm'),
              data: {
                id: n.id,
                type: 'activity_signup',
                num: n.count
              }
            }
          } else if (n.news_type === 'activity_signin') {
            return {
              title: n.title,
              dateTime: moment.unix(n.last_sign_time).format('YYYY-MM-DD HH:mm'),
              data: {
                id: n.id,
                type: 'activity_signin',
                num: n.count
              }
            }
          } else {
            return {
              title: n.title,
              dateTime: moment.unix(n.latest_donate_time).format('YYYY-MM-DD HH:mm'),
              data: {
                id: n.id,
                type: 'cf',
                num: n.count_user_paid + n.extra_donate_count,
                money: n.sum_paid + n.extra_donate_amount
              }
            }
          }
        })
        commit(mTypes.DASHBOARD_SET_NEWS, { news, append })
        commit(mTypes.SET_LOADING, { key: aTypes.DASHBOARD_GET_NEWS, loading: false })
      },
      commit
    }, { page, perPage: 5 })
  },
  [aTypes.DASHBOARD_GET_DIALOG] ({ commit }) {
    const DIALOG_KEY = 'lingxi-mobile-dialog-1'
    const html = `
      <h1>灵析从此移动起来了！</h1>
      <p class="has-text-left"><em>1</em> 所有联系人信息，都可以搜索了；</p>
      <p class="has-text-left"><em>2</em> 表单、筹款的最新进度，一键快速查询；</p>
      <p class="has-text-left"><em>3</em> 还有各种小惊喜，等你去发现！</p>
    `
    const buttonText = '朕知道了'
    if (!getLocalStorageItem(DIALOG_KEY)) {
      commit(mTypes.SET_DIALOG_HTML, { html, buttonText })
      setLocalStorageItem(DIALOG_KEY, 'true')
    }
  },
  [aTypes.DASHBOARD_GET_TEAM_INFO] ({ commit }) {
    api.dashboard.getUserGuideGift({
      success: res => {
        commit(mTypes.DASHBOARD_SET_TEAM_INFO, { data: res.body.message })
      },
      commit
    })
  }
}

const mutations = {
  [mTypes.DASHBOARD_SET_STAT] (state, stats) {
    for (let i = 0; i < 4; i++) {
      state.stats[i].value = stats[i]
    }
  },
  [mTypes.DASHBOARD_SET_NEWS] (state, { news, append }) {
    if (append) {
      state.news = state.news.concat(news)
    } else {
      state.news = news
    }
  },
  [mTypes.DASHBOARD_SET_TEAM_INFO] (state, { data }) {
    state.isGifted = data
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js